import { isRouteErrorResponse, useRouteError } from "@remix-run/react"
import { useMemo } from "react"
import Button from "./Button"

const DefaultErrorBoundary = () => {
  const error = useRouteError()

  const message = useMemo(() => {
    if (isRouteErrorResponse(error)) {
      return error.data
    }

    if (error instanceof Error) {
      return error.message
    }

    return String(error)
  }, [error])
  return (
    <div className="mx-auto max-w-camp-container-mobile md:max-w-camp-container-limit bg-[url('/images/404-bg-mobile.webp')] sm:bg-[url('/images/404-bg.webp')] bg-cover bg-[center_top_-7rem] bg-no-repeat bg-[#fcc031] sm:bg-bottom pt-24 md:pt-48 md:pb-48 text-center w-full relative flex-grow overflow-hidden">
      <h1 className="text-[64px] md:text-[128px] text-[#455A63] font-serif z-10 relative">
        Oh no!!
      </h1>
      <h2 className="text-5xl md:text-[64px] text-[#E3AD26] font-serif max-w-[12rem] md:max-w-[28rem] mx-auto z-10 relative mix-blend-multiply">
        That page isn't here
      </h2>
      {message != "Page not found." && <p className="mt-4">{message}</p>}
      <div className="px-8 md:px-0 grid grid-cols-1 md:grid-cols-3 gap-4 max-w-3xl mx-auto z-10 relative mt-8">
        <Button customBackgroundColor="#1F355D" url="/shop-home">
          <p className="md:text-lg">SHOP NOW</p>
        </Button>
        <Button customBackgroundColor="#1F355D" url="/experiences">
          <p className="md:text-lg">EXPLORE EXPERIENCES</p>
        </Button>
        <Button customBackgroundColor="#1F355D" url="/contact">
          <p className="md:text-lg">CONTACT US</p>
        </Button>
      </div>
    </div>
  )
}

export default DefaultErrorBoundary
